import { Button, Col, Form, Row, } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  initUpdate,
  resetError,
  resetStatus,
} from "../store/userProfileSlice";
import UserNameModal from "./UserNameModal";
import UserEmailModal from "./UserEmailModal";
import UserPhoneModal from "./UserPhoneModal";
import { toast, ToastContainer } from "react-toastify";


const ProfileDetails = () => {


  const [changeName, setChangeName] = useState(false);
  const [changePhoneShow, setChangePhoneShow] = useState(false);
  const [changeEmail, setChangeEmail] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const { status, error, data, verifyMessage } = useSelector((state) => state?.userProfile);
  const user = useSelector((state) => state?.auth?.user);
 

  useEffect(() => {
    dispatch(
      initUpdate({
        name: user?.name,
        email: user?.email,
        phone: user?.phone,
      })
    );
  }, []);

  useEffect(() => {
    if (status) {
      toast.success(verifyMessage)
      dispatch(resetStatus());
      setChangeName(false);
      setChangeEmail(false);
      setChangePhoneShow(false);
      setLoading(false);
    }
  }, [status]);

  useEffect(() => {
    if (error) {
      toast.error("Failed to update profile. Please try again.")
      setLoading(false);
      dispatch(resetError());
    }
  }, [error]);

  return (
    <>

      <ToastContainer />
      <Row className="px-3">
        <Col lg={6} style={{ borderRadius: "5px" }}>
          <Row className="d-flex mt-5 justify-content-start align-items-center">
            <Col lg={10}>
              <Form.Group>
                <Form.Label className="mb-0" style={{ fontSize: "14px", fontWeight: 600 }}>
                  Profile Name
                </Form.Label>
                <Button
                  variant="link p-0 mx-2"
                  onClick={() => setChangeName(true)}
                  disabled={loading}
                >
                  Change
                </Button>
              </Form.Group>
            </Col>
          </Row>
          <Row className="d-flex justify-content-start align-items-center">
            <Col lg={10}>
              <Form.Label style={{ fontSize: "13px", fontWeight: 500 }}>
                {data?.name}
              </Form.Label>
            </Col>
          </Row>
          <Row className="d-flex mt-5 justify-content-start align-items-center">
            <Col lg={10}>
              <Form.Group>
                <Form.Label className="mb-0" style={{ fontSize: "14px", fontWeight: 600 }}>
                  Email
                </Form.Label>
                <Button
                  variant="link p-0 mx-2"
                  onClick={() => setChangeEmail(true)}
                  disabled={loading}
                >
                  Change
                </Button>
              </Form.Group>
            </Col>
          </Row>
          <Row className="d-flex justify-content-start align-items-center">
            <Col lg={10}>
              <Form.Group>
                <Form.Label style={{ fontSize: "13px", fontWeight: 500 }}>
                  {data?.email}
                </Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row className="d-flex mt-5 justify-content-start align-items-center">
            <Col lg={10}>
              <Form.Group>
                <Form.Label className="mb-0" style={{ fontSize: "14px", fontWeight: 600 }}>
                  Phone
                </Form.Label>
                <Button
                  variant="link p-0 mx-2"
                  onClick={() => setChangePhoneShow(true)}
                  disabled={loading}
                >
                  Change
                </Button>
              </Form.Group>
            </Col>
          </Row>
          <Row className="d-flex mb-5 justify-content-start align-items-center">
            <Col lg={10}>
              <Form.Group>
                <Form.Label style={{ fontSize: "13px", fontWeight: 500 }}>
                  {data?.phone}
                </Form.Label>
              </Form.Group>
            </Col>
          </Row>
        </Col>
        <Col lg={3}></Col>
      </Row>

      {changeName && <UserNameModal show={changeName} setShow={setChangeName} />}
      {changeEmail && <UserEmailModal show={changeEmail} setShow={setChangeEmail} />}
      {changePhoneShow && <UserPhoneModal show={changePhoneShow} setShow={setChangePhoneShow} />}
    </>
  );
};

export default ProfileDetails;
